import { createSlice } from "@reduxjs/toolkit";
import {
  CONTENT_SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_START,
  SEARCH_SUCCESS,
  UPDATE_SEARCH_PARAMS_FROM_URL,
} from "../actionTypes";

export interface MetaState {
  init: boolean;
  inFlight: boolean;
}

export const metaInitialState: MetaState = {
  init: false,
  inFlight: false,
};

export const metaSlice = createSlice({
  name: "meta",
  initialState: metaInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(UPDATE_SEARCH_PARAMS_FROM_URL, (state) => {
        state.inFlight = true;
      })
      .addCase(SEARCH_START, (state) => {
        state.inFlight = true;
      })
      .addCase(SEARCH_FAILURE, (state) => {
        state.inFlight = false;
      })
      .addCase(SEARCH_SUCCESS, (state) => {
        state.init = true;
        state.inFlight = false;
      })
      .addCase(CONTENT_SEARCH_SUCCESS, (state) => {
        state.inFlight = false;
      });
  },
});

export const metaReducer = metaSlice.reducer;
